import StoryblokService from "@lib/storyblok/templates/storyblok-service.class";
class ErrorImagesStoryblokService extends StoryblokService {
  constructor() {
    super();
    this.baseURL += "/financial_entity/error_images";
  }
  async getErrorImage(errorCode) {
    return this.getSingleImage("".concat(this.baseURL, "/").concat(errorCode));
  }
}
const errorImagesStoryblokService = new ErrorImagesStoryblokService();
export default errorImagesStoryblokService;